import React from 'react';
import { BottomNavigation } from './BottomNavigation';

interface LayoutProps {
  children: React.ReactNode;
  showNav?: boolean;
}

export const Layout: React.FC<LayoutProps> = ({
  children,
  showNav = true,
}) => {
  return (
    <div className="min-h-full" style={{ background: '#F5F7FA', paddingBottom: showNav ? 'calc(66px + env(safe-area-inset-bottom, 0px))' : '0px' }}>
      <main className="safe-top">{children}</main>
      {showNav && <BottomNavigation />}
    </div>
  );
};
